export default __webpack_public_path__ + "static/media/Group.2cac9391.svg";